import React from 'react';

interface ContentMessageProps {
  title: string;
  body: string;
}

// The shared shape for the hub's terminal states (page not found, load failure).
//
// Left-aligned on the sheet rather than centred in the viewport: this is still a page of the
// hub, and a centred full-height panel reads as an error screen bolted on from somewhere else.
// The title is a statement, so it takes EB Garamond like every other statement here.
const ContentMessage: React.FC<ContentMessageProps> = ({ title, body }) => (
  <div className="max-w-measure py-24">
    <h1 className="font-display text-step-3 leading-[1.05] tracking-[-0.02em] text-ink">{title}</h1>
    <p className="mt-4 text-step-0 text-ink-muted">{body}</p>
  </div>
);

export default ContentMessage;
